import apiClient from '../apiClient';

const DAY_KEYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

const createDefaultOpeningTimes = () =>
  DAY_KEYS.reduce((acc, day) => {
    acc[day] = [];
    return acc;
  }, {});

const normalizeTimeString = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  const match = trimmed.match(/^(\d{1,2}):(\d{2})$/);
  if (!match) {
    return null;
  }

  const hours = Number.parseInt(match[1], 10);
  const minutes = Number.parseInt(match[2], 10);

  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
    return null;
  }

  if (hours < 0 || minutes < 0 || minutes > 59) {
    return null;
  }

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

const normalizeOpeningTimes = (input) => {
  const defaults = createDefaultOpeningTimes();

  if (!input || typeof input !== 'object') {
    return defaults;
  }

  return DAY_KEYS.reduce((acc, day) => {
    const value = input?.[day];
    if (!Array.isArray(value)) {
      acc[day] = [];
      return acc;
    }

    acc[day] = value
      .map((interval) => {
        if (!interval || typeof interval !== 'object') {
          return null;
        }

        const open = normalizeTimeString(interval.open);
        const close = normalizeTimeString(interval.close);

        if (!open || !close) {
          return null;
        }

        return { open, close };
      })
      .filter(Boolean);

    return acc;
  }, defaults);
};

const normalizeLocation = (location) => {
  if (!location) {
    return null;
  }

  return {
    id: location?.id ?? location?._id,
    name: location?.name ?? '',
    address: location?.address ?? '',
    active: location?.active ?? true,
    openingTimes: normalizeOpeningTimes(location?.openingTimes ?? {}),
    raw: location,
  };
};

export const fetchLocations = async () => {
  const response = await apiClient.get('/locations');
  const data = Array.isArray(response?.data) ? response.data : [];
  return data.map(normalizeLocation).filter(Boolean);
};

export default {
  fetchLocations,
};
